import React from 'react'
import { useAnalytics } from 'reactfire'

import { Wrap, Title, /*Hr, */ Paragraph, ResponseMessage } from './styled'

import { Modal } from 'src/components/Modal'
import { FriendsIcon } from 'src/components/Icons'
// import { Button } from 'src/components/Modal/styled'
import { InviteInput } from 'src/components/Inputs/InviteInput/InviteInput'
import { inviteConnection } from 'src/api/connections/connections'
import { analyticsEvents } from 'src/constants/analytics/events'

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const InviteModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { logEvent } = useAnalytics()

  const [isSuccessful, setIsSuccessful] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [error, setError] = React.useState<string>()

  const handleInviteFriend = async (userInput: string) => {
    setIsSuccessful(false)
    setError(undefined)
    if (userInput.length > 0) {
      try {
        setIsLoading(true)
        const connection = await inviteConnection(userInput)
        if (connection) {
          setIsSuccessful(true)
          setError(undefined)
          logEvent(analyticsEvents.inviteFriendsInvited)
        }
      } catch (err) {
        if (err.message) {
          setError(err.message)
        }
      }
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    if (isOpen) {
      logEvent(analyticsEvents.inviteFriendsOpened)
    }
  }, [isOpen, logEvent])

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Wrap>
        <FriendsIcon />
        <Title>Invite your friends and compare your results!</Title>
        <Paragraph light>
          Invite your friends and compare your results!
        </Paragraph>
        <InviteInput
          onSubmit={async ({ emailOrUsername }) =>
            await handleInviteFriend(emailOrUsername)
          }
          isLoading={isLoading}
        />
        {isSuccessful && (
          <ResponseMessage>Friend successfully invited</ResponseMessage>
        )}
        {error && <ResponseMessage error>{error}</ResponseMessage>}
        {/* <Hr />
        <Paragraph>Or send the invitation link</Paragraph>
        <Button>Share the link</Button> */}
      </Wrap>
    </Modal>
  )
}
